import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DocumentoService } from './documento.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { CampoAdicionalService } from '../campo-adicional/campo-adicional.service';
import { TipoDato } from 'src/app/shared/enumeraciones/tipo-dato.enum';
import { MatDialog } from '@angular/material/dialog';
import { AssociateQuestionsComponent } from '../campo-adicional/components/associate-questions/associate-questions.component';
import { first } from 'rxjs/operators';
import { textChangeRangeIsUnchanged } from 'typescript';

@Component({
	selector: 'app-documento',
	templateUrl: './documento.component.html',
	styleUrls: ['./documento.component.scss']
})
export class DocumentoComponent implements OnInit {
	alphanumericValidPattern = "[a-zA-Z0-9 ]*";

	dataTabla: DatoPaginadoModel;
	headerDocumento: Array<string>;
	formDocumento: FormGroup;
	selectDocumento: any;

	paginaActual: number;
	// filtros
	filtro: FormGroup;
	public isCollapsed = true;
	listTipoDato: Array<any> = [];
	idTipoDatoSelected: number;
	tipoDatoSelectedText: number;
	container: any;
	containerCampoRegistro: any;
	containerMultipleCaracteristica: any;
	containerAlertForm: any;
	listadoRespuesta = [
		{ index: 1, respuesta: 'Si' },
		{ index: 2, respuesta: 'No' }
	];
	listadoMultipleCarac = [
		{ descripcion: '', caracteristicas_opciones_id: 0 }
	];
	indexMultipleCarac: number = 1;
	dataToEdit: any;
	multipleFeatureData : Array<any> = [];

	multipleId : number;
	documentoList : Array<any> = [];

	constructor(
		private formBuilder: FormBuilder,
		private campoAdicionalService: CampoAdicionalService,
		private documentoService: DocumentoService,
		private modalService: NgbModal,
		public dialog: MatDialog) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.createForm();

		this.onConsultarDocumento(1);

		this.selectDocumento = null;
		this.paginaActual = 1;

	}

	ngOnInit() {
		this.container = document.getElementById('containerPreguntasMultiples');
		this.containerCampoRegistro = document.getElementById('containerCampoRegistros');
		this.containerMultipleCaracteristica = document.getElementById('containerMultipleCaracteristica');
		this.containerAlertForm = document.getElementById('ContainerAlertFormMC');

		this.listaTipoDatos();
		this.listaMultipleFeature();
		this.headerDocumento = [
			'Descripción',
			'Tipo Dato',
			'Requiere número de certificado',
			'Se muestra para Comerciante',
			'Se muestra para No Comerciante',
			'Estado', 'Acción'
		];

		this.getAllDocumento();
	}

	getAllDocumento() {
		this.documentoService.getAll().subscribe(
		(res) => {
			if (res.result) {
			const { data } = res;
			this.documentoList = data;
			}
		})
	}

	catchMultipleDataTypeId() {
		this.dataTabla.items.forEach((item) => {
			if (!item.descripcion_tipo_dato.includes('MULTIPLE_CARACTERISTICA')) {
				if (item.descripcion_tipo_dato.includes('MULTIPLE')) {
					this.multipleId = item.tipo_dato_id
				}
			}
		})
	}

	openAssociateQuestions( entry? : any ) {
		const dialogRef = this.dialog.open(AssociateQuestionsComponent, {
			data: { entry, list : this.documentoList, isDocument: true }
		});
	}

	listaTipoDatos() {
		this.campoAdicionalService.getTipoDato().subscribe(resultado => {
			if (resultado.data) {
				this.listTipoDato = resultado.data;
			}
		});
	}

	createForm() {
		this.formDocumento = this.formBuilder.group({
			tipo_dato_id: [null, Validators.required],
			Nombre_varios_registros: [null,
				[Validators.pattern(this.alphanumericValidPattern)]
			],
			descripcion: [null, Validators.required],
			requiere_numero_certificado: [null, Validators.required],
			aplica_comerciante: [null, Validators.required],
			aplica_no_comerciante: [null, Validators.required],
			activo: [true],

		});

		this.filtro = this.formBuilder.group({
			descripcion: [null],
			requiere_numero_certificado: [null],
			activo: [null],
		});
	}

	commercialResult( check? : boolean, commercialType? : string ) {
		if (check) {
		  if (commercialType === 'aplica_comerciante') {
			this.formDocumento.controls['aplica_no_comerciante'].clearValidators();
		  } else {
			this.formDocumento.controls['aplica_comerciante'].clearValidators();
		  }
		} else {
		  if (!this.formDocumento.controls['aplica_comerciante'].value &&
		  !this.formDocumento.controls['aplica_no_comerciante'].value) {

			this.formDocumento.controls['aplica_comerciante'].setValue(false);
			this.formDocumento.controls['aplica_no_comerciante'].setValue(false);

			this.formDocumento.controls['aplica_comerciante'].setValidators(Validators.requiredTrue);
			this.formDocumento.controls['aplica_no_comerciante'].setValidators(Validators.requiredTrue);
		  }
		}

		this.formDocumento.controls['aplica_no_comerciante'].updateValueAndValidity();
		this.formDocumento.controls['aplica_comerciante'].updateValueAndValidity();
	}

	onConsultarDocumento(page: number) {
		this.documentoService.get({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
					this.catchMultipleDataTypeId();
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarDocumento(value);
	}

	onAgregarDocumento() {
		let arrayRespuesta = [];
		let arrayMultipleCarac = [];
		const inputRespuesta = document.getElementsByName('inputRespuestas[]');
		const titulos = document.getElementsByName('titulo_mult_carac[]');
		const caracteristicas = document.getElementsByName('caracteristica_mult_carac[]');

		// MULTIPLE
		if(this.idTipoDatoSelected === TipoDato.MULTIPLE){
			for(let i=0; i < inputRespuesta.length; i++){
				let tempInput = inputRespuesta[i] as HTMLInputElement;
				let temp = {
					documento_id: 0,
					documento_opcion_id: 0,
					valor: '',
					descripcion: tempInput.value
				};
				arrayRespuesta.push(temp);
			}
		}

		//MULTIPLE CARACTERISTICA
		if(this.idTipoDatoSelected === TipoDato.MULTIPLE_CARACTERISTICAS){
			for(let i=0; i < titulos.length; i++){
				let tmpTitulo = (titulos[i] as HTMLInputElement).value;
				let tmpCaracteristica = (caracteristicas[i] as HTMLInputElement).value;
				let temp = {
					descripcion: tmpTitulo,
					caracteristicas_opciones_id: tmpCaracteristica
				};
				arrayMultipleCarac.push(temp);
			}

			this.formDocumento.value.caracateristicas_opciones = arrayMultipleCarac;
		} else{
			this.formDocumento.value.caracateristicas_opciones = [];
		}

		this.formDocumento.value.opciones = arrayRespuesta;
		this.formDocumento.value.documento_id = 0;
		this.formDocumento.value.descripcion_tipo_dato = this.tipoDatoSelectedText;
		this.formDocumento.value.tipo_dato_id = this.idTipoDatoSelected;

		this.documentoService.create(
			{
				...this.formDocumento.value,
				activo: 1
			}
		).subscribe(resultado => {
			if (resultado.result) {
				this.onConsultarDocumento(this.paginaActual);
				this.formDocumento.reset();

				this.container.classList.add('d-none');
				this.listadoRespuesta.splice(2, this.listadoRespuesta.length);

				this.containerMultipleCaracteristica.classList.add('d-none');
					this.listadoMultipleCarac = [
						{ descripcion: '', caracteristicas_opciones_id: 0 }
					];
			}
		});
	}

	onOperarDocumento() {
		if (!this.selectDocumento) {
			this.onAgregarDocumento();
		} else {
			this.onModificarDocumento();
		}
	}

	onCargarDocumento(entry: any) {
		const idDocument: number = entry.documento_id;

		this.documentoService.getById(idDocument).subscribe((response) => {
			this.dataToEdit = response.data;
			let opcionesRespuesta = this.dataToEdit.opciones;
			let opcionesmultipleCaracteristica = this.dataToEdit.caracateristicas_opciones;

			this.dataToEdit.activo = entry.activo ? 1 : 0;
			this.dataToEdit.requiere_numero_certificado = this.dataToEdit.requiere_numero_certificado ? 1 : 0;

			if(this.dataToEdit.tipo_dato_id === TipoDato.VARIOS_REGISTROS){/* Mostrar el contenedor de respuestas (Tipo dato, VARIOS_REGISTROS) */
				this.containerCampoRegistro.classList.remove('d-none');
				this.dataToEdit.Nombre_varios_registros = this.dataToEdit.nombre_varios_registros;
			} else if(this.dataToEdit.tipo_dato_id === TipoDato.MULTIPLE){ /* Mostrar el contenedor de respuestas (Tipo dato, MULTILE) */
				this.container.classList.remove('d-none');
				this.listadoRespuesta = [];

				if(opcionesRespuesta.length > 0){
					for(let i = 0; i < opcionesRespuesta.length; i++){
						let temp = {
							index: this.listadoRespuesta.length + 1,
							respuesta: opcionesRespuesta[i].descripcion
						};

						this.listadoRespuesta.push(temp);
					}
				}
			} else if(this.dataToEdit.tipo_dato_id === TipoDato.MULTIPLE_CARACTERISTICAS){ /* Mostrar el contenedor de respuestas (Tipo dato, MULTILE CARACTERISTICA) */
				const titulos = document.getElementsByName('titulo_mult_carac[]');
				const caracteristicas = document.getElementsByName('caracteristica_mult_carac[]');

				this.containerMultipleCaracteristica.classList.remove('d-none');
				this.listadoMultipleCarac = [];

				if (opcionesmultipleCaracteristica.length > 0 ){
					for(let i = 0; i < opcionesmultipleCaracteristica.length; i++){
						let temp = {
							descripcion: opcionesmultipleCaracteristica[i].descripcion,
							caracteristicas_opciones_id: opcionesmultipleCaracteristica[i].caracteristicas_opciones_id
						};

						this.listadoMultipleCarac.push(temp);
					}
				}
			}else{
				this.container.classList.add('d-none');
				this.listadoRespuesta.splice(2, this.listadoRespuesta.length);
				this.containerCampoRegistro.classList.add('d-none');
			}

			this.formDocumento.patchValue({
				...this.dataToEdit,
			});

			this.selectDocumento = this.dataToEdit;
		});
	}

	onEliminarDocumento(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.documentoService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					// tslint:disable-next-line:max-line-length
					const index = this.dataTabla.items.map(function (e) { return e.documento_id; }).indexOf(entry.documento_id);
					this.dataTabla.items.splice(index, 1);
					this.selectDocumento = null;
					this.formDocumento.reset();
				}
			});
		});
	}

	onModificarDocumento() {
		const inputRespuesta = document.getElementsByName('inputRespuestas[]');
		const titulos = document.getElementsByName('titulo_mult_carac[]');
		const caracteristicas = document.getElementsByName('caracteristica_mult_carac[]');
		let opcionesOld = this.dataToEdit.opciones;
		let arrayRespuestaNew = [];
		let arrayRespuestaEditadas = [];
		let arrayMultipleCarac = [];
		this.idTipoDatoSelected = this.dataToEdit.tipo_dato_id;

		/* Obtener el listado de respuestas, cuando tipo de dato MULTIPLE */
		if(this.idTipoDatoSelected === TipoDato.MULTIPLE){
			for(let i=0; i < inputRespuesta.length; i++){
				let tempInput = inputRespuesta[i] as HTMLInputElement;
				let temp = {
					campo_adicional_opcion_id: 0,
					campo_adicional_id: 0,
					valor: '',
					descripcion: tempInput.value
				};
				arrayRespuestaNew.push(temp);
			}
		}

		/* Obtener cambios de las respuestas */
		for(let i=0; i < arrayRespuestaNew.length; i++){
			let descripcionNew = arrayRespuestaNew[i].descripcion;
			let existRespuesta: number = 0;

			for(let j=0; j < opcionesOld.length; j++){
				let descripcionOld = opcionesOld[j];
				let temp: any;

				if(descripcionNew === descripcionOld.descripcion){
					temp = {
						documento_id: descripcionOld.documento_id,
						documento_opcion_id: descripcionOld.documento_opcion_id,
						valor: descripcionOld.valor,
						descripcion: descripcionOld.descripcion
					}
					arrayRespuestaEditadas.push(temp);
				} else {
					existRespuesta++;
				}
			}

			// Obtener los respuestas nuevas
			if(existRespuesta === opcionesOld.length){
				let tempNew = {
					documento_id: 0,
					documento_opcion_id: 0,
					valor: '',
					descripcion: descripcionNew
				};
				arrayRespuestaEditadas.push(tempNew);
			}
		}

		/* MULTIPLE CARACTERISTICA */
		if(this.idTipoDatoSelected === TipoDato.MULTIPLE_CARACTERISTICAS){
			for(let i=0; i < titulos.length; i++){
				let tmpTitulo = (titulos[i] as HTMLInputElement).value;
				let tmpCaracteristica = (caracteristicas[i] as HTMLInputElement).value;
				let objectCaracteristicaOpciones = this.dataToEdit.caracateristicas_opciones;
				//let findCaracteristica = objectCaracteristicaOpciones.find( tmp => tmp.caracteristicas_opciones_id == tmpCaracteristica );
        let findCaracteristica = objectCaracteristicaOpciones.find( tmp => tmp.descripcion == tmpTitulo );

        let temp = {
					Valor_Registros: null,
					campo_adicional_id: null,
					caracteristicas_campo_adicional_opciones_id: null,
					caracteristicas_documento_opciones_id: findCaracteristica ? findCaracteristica.caracteristicas_documento_opciones_id : 0,
					caracteristicas_opciones_descripcion: '',
					caracteristicas_opciones_id: tmpCaracteristica,
					descripcion: tmpTitulo
				};
				arrayMultipleCarac.push(temp);
			}

			this.formDocumento.value.caracateristicas_opciones = arrayMultipleCarac;
		} else{
			this.formDocumento.value.caracateristicas_opciones = [];
		}

		this.formDocumento.value.opciones = arrayRespuestaEditadas;
		this.formDocumento.value.documento_id = this.dataToEdit.documento_id;
		this.formDocumento.value.descripcion_tipo_dato = this.dataToEdit.descripcion_tipo_dato;
		this.formDocumento.value.tipo_dato_id = this.idTipoDatoSelected;

		this.documentoService.update({
			...this.formDocumento.value,
			documento_id: this.selectDocumento.documento_id
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarDocumento(this.paginaActual);
					this.formDocumento.reset();
					this.selectDocumento = null;

					this.container.classList.add('d-none');
					this.listadoRespuesta.splice(2, this.listadoRespuesta.length);

					this.containerMultipleCaracteristica.classList.add('d-none');
					this.listadoMultipleCarac = [
						{ descripcion: '', caracteristicas_opciones_id: 0 }
					];
				}
			});

			//const resultado = inventario.find( fruta => fruta.nombre === 'cerezas' );
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarDocumento(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}

	limpiarDocumento() {
		this.selectDocumento = null;
		this.formDocumento.reset();
		this.createForm();

		this.container.classList.add('d-none');
		this.listadoRespuesta.splice(2, this.listadoRespuesta.length);
		this.containerCampoRegistro.classList.add('d-none');
	}

	tipoDatoSelected(event: any){
		this.idTipoDatoSelected = Number(event.currentTarget.value);
		this.tipoDatoSelectedText = event.target.options[event.target.options.selectedIndex].text;

		if(this.idTipoDatoSelected === TipoDato.MULTIPLE){
			this.container.classList.remove('d-none');

			this.containerCampoRegistro.classList.add('d-none');
			this.containerMultipleCaracteristica.classList.add('d-none');
		} else if(this.idTipoDatoSelected === TipoDato.VARIOS_REGISTROS){
			this.containerCampoRegistro.classList.remove('d-none');

			this.container.classList.add('d-none');
			this.listadoRespuesta.splice(2, this.listadoRespuesta.length);

			this.containerMultipleCaracteristica.classList.add('d-none');
		} else if(this.idTipoDatoSelected === TipoDato.MULTIPLE_CARACTERISTICAS){
			this.containerMultipleCaracteristica.classList.remove('d-none');

			this.container.classList.add('d-none');
			this.listadoRespuesta.splice(2, this.listadoRespuesta.length);

			this.containerCampoRegistro.classList.add('d-none');
		} else{
			this.container.classList.add('d-none');
			this.listadoRespuesta.splice(2, this.listadoRespuesta.length);

			this.containerCampoRegistro.classList.add('d-none');
			this.containerMultipleCaracteristica.classList.add('d-none');
		}
	}

	// MULTILPE
	agregarRespuesta(){
		let totalRespuesta = this.listadoRespuesta.length;

		this.listadoRespuesta.push(
			{ index: totalRespuesta + 1, respuesta: '' }
		);
	}

	eliminarRespuesta(index){
		const indexofObject = (this.listadoRespuesta).findIndex((object) => {
			return object.index === index;
		});
		(this.listadoRespuesta).splice(indexofObject, 1);
	}

	// MULTIPLE CARACTERISITCA
	listaMultipleFeature(){
		this.campoAdicionalService.getMultipleFeatureData().subscribe((res) => {
			if (res.data) {
				this.multipleFeatureData = res.data;
			}
		});
	}

	crearNuevoCampo(){
		const titulos = document.getElementsByName('titulo_mult_carac[]');
		const caracteristicas = document.getElementsByName('caracteristica_mult_carac[]');
		let totalEmpty: number = 0;

		for(let i=0; i < titulos.length; i++){
			let tmpTitulo = (titulos[i] as HTMLInputElement).value;
			let tmpCaracteristica = (caracteristicas[i] as HTMLInputElement).value;


			if(tmpTitulo && tmpCaracteristica){
				this.listadoMultipleCarac[i].descripcion = tmpTitulo;
				this.listadoMultipleCarac[i].caracteristicas_opciones_id = Number(tmpCaracteristica);
			} else{
				totalEmpty++;
			}
		}

		if(totalEmpty === 0){
			this.listadoMultipleCarac.push({ descripcion: '', caracteristicas_opciones_id: 0 });

			this.containerAlertForm.classList.add('d-none');
		} else if(totalEmpty > 0){
			console.log('CAMPOS VACIOS')
			this.containerAlertForm.classList.remove('d-none');
		}
	}

	eliminarMultipleCaracteristica(index){
		this.listadoMultipleCarac.splice(index, 1);
	}
}
